import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/formSubmissionReport'
import Component from 'components/Reports/FormSubmissionReport'

export default createListViewContainer({ actions, selectors: selectors.formSubmissionReport })(Component)
